import type { AnswerRecord } from '@/shared/offline';

/** De statussen van een opname, zoals de API ze noemt. */
export const INSPECTION_STATUSES = [
    'not_started',
    'in_progress',
    'completed',
    'submitted',
] as const;

export type InspectionStatus = (typeof INSPECTION_STATUSES)[number];

export const INSPECTION_STATUS_LABELS: Record<InspectionStatus, string> = {
    not_started: 'Nog niet gestart',
    in_progress: 'Opname bezig',
    completed: 'Afgerond',
    submitted: 'Ingediend',
};

export function isInspectionStatus(value: string): value is InspectionStatus {
    return (INSPECTION_STATUSES as readonly string[]).includes(value);
}

/**
 * De velden van één antwoord die de inspecteur kan wijzigen, in de vorm van
 * het draadformaat (`inspection_answer`) maar in camelCase. Bedragen zijn
 * strings met twee decimalen of `null` ("de norm geldt").
 */
export interface AnswerFields {
    optionIds: number[] | null;
    valueNumber: number | null;
    valueText: string | null;
    reportText: string | null;
    /** Waar het gebrek zit, in een handvol woorden; `null` als de inspecteur niets zei. */
    location: string | null;
    directCost: string | null;
    termCost: string | null;
    improvementCost: string | null;
    costGroupId: number | null;
    urgency: string | null;
    nhgClassification: string | null;
}

export const EMPTY_ANSWER_FIELDS: AnswerFields = {
    optionIds: null,
    valueNumber: null,
    valueText: null,
    reportText: null,
    location: null,
    directCost: null,
    termCost: null,
    improvementCost: null,
    costGroupId: null,
    urgency: null,
    nhgClassification: null,
};

export function answerFieldsOf(record: AnswerRecord | undefined): AnswerFields {
    if (!record) {
        return EMPTY_ANSWER_FIELDS;
    }

    return {
        optionIds: record.optionIds,
        valueNumber: record.valueNumber,
        valueText: record.valueText,
        reportText: record.reportText,
        location: record.location,
        directCost: record.directCost,
        termCost: record.termCost,
        improvementCost: record.improvementCost,
        costGroupId: record.costGroupId,
        urgency: record.urgency,
        nhgClassification: record.nhgClassification,
    };
}
